import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { applyDocumentSeo, getSeoForPath } from "../lib/siteSeo"

type ModalRouteState = { backgroundLocation?: { pathname: string } } | null

/** Title, description и canonical по текущему разделу — для сниппета и быстрых ссылок Яндекса. */
export function usePageSeo() {
    const location = useLocation()
    const state = location.state as ModalRouteState
    const pathname = state?.backgroundLocation?.pathname ?? location.pathname

    useEffect(() => {
        applyDocumentSeo(getSeoForPath(pathname))
    }, [pathname])
}
